/* global COMMENTS_GQL, COMMENTS_CLIENT_ID */
import React, { useContext } from 'react';
import {
  ApolloClient,
  InMemoryCache,
  from,
  HttpLink,
} from '@apollo/client';
import BrowserStore from 'store2';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

// apollo global error link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  // const handleUserAuth = useUserAuth.getState().handleUserAuth;
  // graphQL error
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      const error = extensions?.validation
        ? Object.values(extensions.validation)
          .find(el => el)
          ?.toString()
          ?.replace('input.', '')
          ?.replace('.0', '')
        : message;

      // customToast(error, 'error');

      if (extensions?.category === 'authentication') {
        // handleUserAuth(null);
      }
    });
  }
  // network error
  if (networkError && !graphQLErrors) {
    // handleUserAuth(null);
    // customToast(networkError.message, 'error');
  }
});

// create link
const httpLink = new HttpLink({
  uri: COMMENTS_GQL,
//  credentials: 'include',
});

export const createApolloClient = () => {
  // auth link
  const authLink = setContext((_, { headers }) => {
    const token = BrowserStore.get('gql_token', '');
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
        'X-Client-ID': COMMENTS_CLIENT_ID,
      },
    };
  });

  return new ApolloClient({
    link: from([errorLink, authLink.concat(httpLink)]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
      },
      mutate: {
        awaitRefetchQueries: true,
      },
    },
  });
};

export default createApolloClient;
